
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/vouchers",
      function () {
        return require("private-next-pages/my/vouchers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/vouchers"])
      });
    }
  